import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import PageSourceWrapper from "@core/pages/source/PageSourceWrapper.vue"
import PageSourceInfoGenerale from "@core/pages/source/PageSourceInfoGenerale.vue"
import PageSourceData from "@modules/data/pages/PageSourceData.vue"
import PageSourceAlarm from "@modules/energy-manager/pages/PageSourceAlarm.vue"
import PageSourceFactures from "@modules/courtage/pages/PageSourceFactures.vue"

const sourceShellMeta = {
    requiresAuth: true,
    layout: "header-sidebar",
    sidebar: "source",
} as const

async function ensureAuthUserLoaded(
    authStore: ReturnType<typeof useAuthStore>
): Promise<void> {
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
}

/**
 * Routes fiche source regroupées sous {@link PageSourceWrapper}.
 * Les chemins enfants sont relatifs à `source/:_id_source`.
 */
export const sourceShellRoute: RouteRecordRaw = {
    path: "source/:_id_source",
    component: PageSourceWrapper,
    meta: sourceShellMeta,
    children: [
        {
            path: "",
            redirect: (to: RouteLocationNormalized) => ({
                name: "PageSourceData",
                params: { _id_source: to.params._id_source },
            }),
        },
        {
            path: "data",
            name: "PageSourceData",
            component: PageSourceData,
        },
        {
            path: "info-general",
            name: "PageSourceInfoGenerale",
            component: PageSourceInfoGenerale,
        },
        {
            path: "alarme",
            name: "PageSourceAlarm",
            component: PageSourceAlarm,
            beforeEnter: async (to, _from, next) => {
                const authStore = useAuthStore()
                await ensureAuthUserLoaded(authStore)
                if (authStore.hasOfferEnergyManager) {
                    next()
                } else {
                    next({
                        name: "PageSourceInfoGenerale",
                        params: { _id_source: String(to.params._id_source) },
                    })
                }
            },
        },
        {
            path: "factures",
            name: "PageSourceFactures",
            component: PageSourceFactures,
            beforeEnter: async (to, _from, next) => {
                const authStore = useAuthStore()
                await ensureAuthUserLoaded(authStore)
                // R4 (DEV-714) : module `analyse-facture` ET admin d'entreprise.
                if (
                    authStore.hasModuleAnalyseFacture &&
                    authStore.isCompanyAdmin
                ) {
                    next()
                } else {
                    next({
                        name: "PageSourceInfoGenerale",
                        params: { _id_source: String(to.params._id_source) },
                    })
                }
            },
        },
    ],
}
